import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';

import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './header/header.component';
import { ProductPageComponent } from './product-page/product-page.component';
import { CartPageComponent } from './cart-page/cart-page.component';
import { CheckOutComponent } from './cart-page/check-out/check-out.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { AdminComponent } from './admin/admin.component';
import { CartPageAlertComponent } from './shared/loader/cart-page-alert/cart-page-alert.component';
import { FooterComponent } from './footer/footer.component';
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ProductPageComponent,
    CartPageComponent,
    HeaderComponent,
    LoaderComponent,
    CheckOutComponent,
    AdminComponent,
    CartPageAlertComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
